import clsx from 'clsx';
import { DaymadeLogo } from 'components/layout/header2026';
import { useDrawStore } from 'hooks/stores/useDrawStore';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import { useState } from 'react';
import { useChristmasLogos, useHalloweenLogos } from 'utils/constants';

import { observer } from 'mobx-react-lite';
import EnterHeaderDrawCountdown from './EnterHeaderDrawCountdown';
import styles from './Navigation.module.css';

export const MainEnterFlowNavigation = observer(
  ({ fullWidthNav }: { fullWidthNav?: boolean }) => {
    const { upcomingDrawDate } = useDrawStore();
    const [isChristmas] = useState(useChristmasLogos());
    const [isHalloween] = useState(useHalloweenLogos());

    return (
      <div
        className={clsx(styles.navigation, fullWidthNav && styles.fullWidthNav)}
      >
        <DaymadeLogo
          logoColor="black"
          isChristmas={isChristmas}
          isHalloween={isHalloween}
        />
        {fullWidthNav && (
          <EnterHeaderDrawCountdown
            targetDate={upcomingDrawDate}
            variant="V3"
          />
        )}
      </div>
    );
  },
);

export const V2NavigationRight = observer(() => {
  const { upcomingDrawDate } = useDrawStore();
  const [isChristmas] = useState(useChristmasLogos());
  const [isHalloween] = useState(useHalloweenLogos());
  const { isMobile } = useIsMobile();

  return (
    <div className={clsx(styles.navigation, styles.rightNavigation)}>
      {isMobile && (
        <DaymadeLogo
          logoColor="white"
          isChristmas={isChristmas}
          isHalloween={isHalloween}
        />
      )}
      <EnterHeaderDrawCountdown targetDate={upcomingDrawDate} variant="V2" />
    </div>
  );
});
